import { useEffect } from "react";

interface PageMetaOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function upsertMeta(name: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * 为每个页面设置独立的 TDK（标题 / 描述 / 关键词）。
 */
export function usePageMeta({ title, description, keywords }: PageMetaOptions) {
  useEffect(() => {
    document.title = title;
    if (description) upsertMeta("description", description);
    if (keywords) upsertMeta("keywords", keywords);
  }, [title, description, keywords]);
}